<template>
  <div class="video-player">
    <div v-show="showPoster" class="video-player__poster-container">
      <button class="video-player__poster-play" @click="startVideo">
        <oie-use-svg svg="play" :height="40" :width="40"></oie-use-svg>
      </button>
      <oie-base-image
        :images="posterImage"
        alt-text="Placeholder image for paused video"
        class="video-player__poster"
        @click.native="startVideo"></oie-base-image>
    </div>
    <div v-show="!showPoster" class="video-player__video">
      <div ref="playerElement"></div>
    </div>
  </div>
</template>

<script>
import { createYoutubePlayer, createVimeoPlayer } from '@/core/video-service'

export default {
  props: {
    youtubeId: { type: String, required: false, default: '' },
    vimeoId: { type: String, required: false, default: '' },
    posterImage: { type: String, required: true, default: 'https://placehold.co/384x384/FF4646/white' }
  },
  data() {
    return {
      player: null,
      playerElement: null,
      showPoster: true
    }
  },
  mounted() {
    this.subscribe('pause-video', () => {
      if(this.player) {
        this.player.pause()
      }
    })
  },
  methods: {
    async startVideo() {
      this.showPoster = false
      if(this.youtubeId) {
        this.player = await createYoutubePlayer(this.$refs.playerElement, this.youtubeId)
        this.player.play()
      } else if (this.vimeoId) {
        this.player = await createVimeoPlayer(this.$refs.playerElement, this.vimeoId)
        this.player.play()
      }
    }
  }
}
</script>

<style lang="scss">
.video-player {
  position: relative;
}

.video-player__poster-container {
  position: relative;
}

.video-player__poster-play {
  @include reset-button;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.video-player__poster {
  width: 100%;
  height: auto;
  aspect-ratio: 1 / 1 auto;
  margin: 0 auto;
}

.video-player__video {
  width: fit-content;
  margin: 0 auto;
}

.video-player__video iframe{
  max-width: 100%;
}

</style>
